import React, { useContext, useState, useEffect } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import ClassNames from "classnames";

import { UserIPLocation } from "../Layout";
import LocalizedLink from "../LocalizedLink";
import Container from "../Container";
import ModalRegular from "../ModalRegular";
import TdcxQR from "../../images/footer/tdcxQR.jpg";

import {
  faLinkedinIn,
  faFacebookF,
  faYoutube,
  faInstagram,
  faXTwitter,
  faWeixin,
  faThreads,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LogoBrand from "../Icons/_Logo/TDCX/LogoBrand";
import ContactFloatingButton from "../ContactFloatingButton";
import WhatsAppFloatingButton from "../WhatsAppFloatingButton";

import content from "../../../content/global";
import { getLocalizedPath, getStaticData, isTLD } from "../../helperFunctions";

import * as s from "./s.module.scss";

const Footer = ({ data, variant, locale, alias }) => {
  const { userIPLocation } = useContext(UserIPLocation);
  const [officeCountry, setOfficeCountry] = useState(userIPLocation);

  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";

  const officeData = useStaticQuery(graphql`
    query {
      allStrapiCountry {
        nodes {
          office_name
          country_name
        }
      }
    }
  `);

  const query = () => {
    return `/graphql?query=query{
    pages(filters: { name_: { eq: "HOME_V2" } }){
       data{
        attributes{
          section_title_description_2{
            title_small
            title
          }
        }
      }
    }
  }`;
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isWeekend, setIsWeekend] = useState(false);
  const [isTime, setIsTime] = useState(false);

  useEffect(() => {
    if (userIPLocation !== null) {
      setOfficeCountry(
        officeData.allStrapiCountry.nodes.filter(
          (office) => office.country_name === userIPLocation
        )
      );
    }
  }, [userIPLocation, officeData]);

  useEffect(() => {
    function isWeekendManila() {
      const timeZone = "Asia/Manila";
      const now = new Date();
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        weekday: "short",
      });
      const day = formatter
        .formatToParts(now)
        .find((part) => part.type === "weekday").value;
      if (day === "Sat" || day === "Sun") {
        setIsWeekend(true);
      } else {
        setIsWeekend(false);
      }
    }

    function checkIsTimeSG() {
      const timeZone = "Asia/Singapore";
      const now = new Date();
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hour: "2-digit",
        hour12: false,
      });
      const hour = parseInt(
        formatter.formatToParts(now).find((part) => part.type === "hour").value,
        10
      );
      if (hour >= 9 && hour < 18) {
        setIsTime(true);
      } else {
        setIsTime(false);
      }
    }

    isWeekendManila();
    checkIsTimeSG();
  }, []);

  const handleWechatButton = () => {
    // Custom Google Tag Manager Event
    setModalIsOpen(true);
    typeof window.dataLayer !== "undefined" &&
      window.dataLayer.push({
        event: "Wechat Icon",
      });
  };

  return (
    <>
      {/* {!isTLD("cn") && ()} */}

      {isWeekend
        ? null
        : !isTLD("cn") && (
            <>
              {isTime && <WhatsAppFloatingButton />}
              <ContactFloatingButton
                officeCountry={officeCountry}
                locale={locale}
              />
            </>
          )}
      <div
        className={ClassNames(s.footer, {
          [s.footerPlain]: variant === "plain",
        })}
      >
        <div className={s.footerTop}>
          <Container className={s.container}>
            <div className={s.footerTopWrapper}>
              <div className={s.footerLogo}>
                <div className={s.footerLogoWrapper}>
                  <LocalizedLink to="/">
                    <LogoBrand />
                  </LocalizedLink>
                </div>
              </div>
              <div className={s.footerMenu}>
                <div className={s.footerMenuWrapper}>
                  <Link
                    to={getLocalizedPath(
                      locale,
                      alias,
                      getStaticData(content.services, locale).link
                    )}
                    className={s.footerHeading}
                  >
                    {getStaticData(content.services, locale).title}
                  </Link>
                  <Link
                    to={getLocalizedPath(
                      locale,
                      alias,
                      getStaticData(content.industries, locale).link
                    )}
                    className={s.footerHeading}
                  >
                    {getStaticData(content.industries, locale).title}
                  </Link>
                  <Link
                    to={getLocalizedPath(
                      locale,
                      alias,
                      getStaticData(content.about, locale).link
                    )}
                    className={s.footerHeading}
                  >
                    {getStaticData(content.about, locale).title}
                  </Link>
                  <Link
                    to={getLocalizedPath(
                      locale,
                      alias,
                      getStaticData(content.media, locale).link
                    )}
                    className={s.footerHeading}
                  >
                    {getStaticData(content.media, locale).title}
                  </Link>
                  <Link
                    to={getLocalizedPath(
                      locale,
                      alias,
                      getStaticData(content.careers, locale).link
                    )}
                    className={s.footerHeading}
                  >
                    {getStaticData(content.careers, locale).title}
                  </Link>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <div className={s.footerBottom}>
          <div className={s.footerBackgroundBlock}>
            <div className={s.blockLeft} />
            <div className={s.blockRight} />
          </div>
          <Container className={s.container}>
            <div className={s.footerBottomWrapper}>
              <div className={s.footerSocial}>
                {tdcxCN ? (
                  <ul className={s.footerLists}>
                    <li>
                      <a
                        href={content.social_links.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="linkdin"
                      >
                        <FontAwesomeIcon icon={faLinkedinIn} />
                      </a>
                    </li>
                    <li>
                      <button onClick={() => handleWechatButton()}>
                        <FontAwesomeIcon icon={faWeixin} />
                      </button>
                      <ModalRegular
                        isOpen={modalIsOpen}
                        onRequestClose={() => setModalIsOpen(false)}
                      >
                        <img
                          src={TdcxQR}
                          alt="TDCX Official Account QR Code"
                          style={{ width: "14rem" }}
                        />
                      </ModalRegular>
                    </li>
                  </ul>
                ) : (
                  <ul className={s.footerLists}>
                    <li>
                      <a
                        href={content.social_links.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="linkdin"
                      >
                        <FontAwesomeIcon icon={faLinkedinIn} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={content.social_links.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="facebook"
                      >
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={content.social_links.twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="twitter"
                      >
                        <FontAwesomeIcon icon={faXTwitter} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={content.social_links.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="youtube"
                      >
                        <FontAwesomeIcon icon={faYoutube} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={content.social_links.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="instagramme"
                      >
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={content.social_links.threads}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Threads"
                      >
                        <FontAwesomeIcon icon={faThreads} />
                      </a>
                    </li>
                  </ul>
                )}
              </div>
              <div className={s.footerPolicy}>
                <ul className={s.footerLists}>
                  <li className={s.footerListItem}>
                    <LocalizedLink
                      to={getStaticData(content.terms_of_use, locale).link}
                    >
                      {getStaticData(content.terms_of_use, locale).title}
                    </LocalizedLink>
                  </li>
                  <li className={s.footerListItem}>
                    <LocalizedLink
                      to={getStaticData(content.privacy_policy, locale).link}
                    >
                      {getStaticData(content.privacy_policy, locale).title}
                    </LocalizedLink>
                  </li>
                  <li className={s.footerListItem}>
                    <LocalizedLink
                      to={getStaticData(content.cookies_policy, locale).link}
                    >
                      {getStaticData(content.cookies_policy, locale).title}
                    </LocalizedLink>
                  </li>
                </ul>
              </div>
              <div className={s.footerCopyrights}>
                <p>{getStaticData(content.copyright_text, locale).title}</p>
              </div>
            </div>
          </Container>
        </div>
        {tdcxCN ? (
          <div className={s.footerChina}>
            <Container className={s.container}>
              <div>
                <div>
                  提达客思信息咨询（上海）有限公司｜
                  <a
                    href="https://beian.miit.gov.cn/"
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="沪ICP备20004000号-2"
                  >
                    沪ICP备20004000号-2
                  </a>{" "}
                  ｜业务咨询电话：+86 4000890200
                </div>
              </div>
            </Container>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Footer;
